<template>
  <VpLoaderContainer class="vp-py-12" loading v-if="loading" />

  <VpListLayout
    v-else
    :add-route="{
      name: 'whatsapp-extension-broadcast',
      params: { id: '+' },
    }"
    feature="WHATSAPP_BROADCAST"
    permission="upsert"
  >
    <VpList
      :per-page="25"
      :columns="columns"
      :endpoint="'whatsappExtensionBroadcast'"
      class="vp-h-full"
      ref="list"
      :search="false"
      :request-payload="{
        query: $options.whatsappExtensionBroadcast,
      }"
      :cache="'whatsappExtensionBroadcasts'"
      :title="'Broadcast With Extension'"
      @rowClick="
        $router.push({
          name: 'whatsapp-extension-broadcast-analytics',
          params: {
            id: $event.id,
          },
        })
      "
      feature="WHATSAPP_BROADCAST"
    >
      <template #empty>
        <VpListEmpty :feature="feature" route="whatsapp-extension-broadcast" />
      </template>

      <template #progress="{ item }">
        <ProgressBar class="vp-w-full" :progress="item.summary.progress" />
      </template>

      <template #status="{ item }">
        <Status :value="item.status" />
      </template>
    </VpList>
  </VpListLayout>
</template>

<script>
import ProgressBar from "@/components/progress-bar.vue";

import Status from "../_Status.vue";

//Marketing
import whatsappExtensionBroadcast from "@/views/crm/marketing/whatsapp-broadcast/extension/collection.gql";

export default {
  whatsappExtensionBroadcast,
  props: {
    feature: Object,
  },
  components: {
    ProgressBar,
    Status,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    columns() {
      return [
        { name: "_index", label: "#", fix: true },
        { name: "name", type: "string" },
        { name: "progress", type: "string", width: "300px" },
        {
          name: "status",
          type: "string",
          fix: true,
        },
      ];
    },
  },
};
</script>
